export const ROUTES = {
  main: '/',
  terms: '/terms',
  privacy: '/privacy',
}
